import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Copy, Check } from "lucide-react";

const APP_URL = window.location.origin;

const TEMPLATES = [
  {
    id: "whatsapp",
    title: "WhatsApp Group Message",
    content: `Jai Shree Ram! 🙏

The Aylesbury Hindu Temple is asking all community members to participate in the Buckinghamshire Council Local Plan consultation.

It only takes 10-15 minutes — your responses are pre-filled, you just review and submit from your own device.

Get started: ${APP_URL}

For help: ${APP_URL}/guide
More info: www.aylesburyhindutemple.org`,
  },
  {
    id: "email",
    title: "Email Template",
    content: `Subject: Aylesbury Hindu Temple — Your voice matters in the Buckinghamshire Local Plan consultation

Dear [Name],

The Buckinghamshire Council is currently running a consultation on the Local Plan Sites Survey, which will determine where new developments happen across Aylesbury and surrounding areas.

Our Hindu community has been a growing and valued part of Aylesbury for decades, yet we currently lack dedicated spaces for worship, cultural events, and community gatherings. This consultation is our opportunity to advocate for community facilities.

The Aylesbury Hindu Temple has prepared a tool that pre-fills your responses with our community's key points. You can review, personalise, and submit from your own device in about 10-15 minutes.

Get started here: ${APP_URL}

Every response counts. The more community members who participate, the stronger our voice will be in shaping Aylesbury's future.

Please forward this to family and friends who live in the Aylesbury area.

Jai Shree Ram!

For more information, visit www.aylesburyhindutemple.org`,
  },
  {
    id: "temple",
    title: "Temple / Community Centre Announcement",
    content: `COMMUNITY ACTION: Buckinghamshire Council Consultation
An initiative by Aylesbury Hindu Temple & Trust

Dear members,

Buckinghamshire Council is seeking views on proposed development sites in Aylesbury. This is an important opportunity for our community to be heard.

The Aylesbury Hindu Temple has prepared a tool that makes it easy to submit your response. It takes about 10-15 minutes.

HOW TO PARTICIPATE:
1. Visit ${APP_URL} on your phone or computer
2. Enter your name, email, street name and years in Aylesbury (all optional)
3. Review the pre-filled responses for each site
4. Open the council form in a SEPARATE TAB (keep the AHT page open!)
5. Run the bookmarklet and click Submit on the council form
6. Return to the AHT page tab and click "I've Completed All My Submissions" to confirm

⚠️ IMPORTANT: Keep the AHT page open in its own tab. Open the council form in a NEW tab. You need to return to confirm!

Each person should submit from their own device to ensure each response is genuine and unique.

Please encourage your family members who live in the area to participate as well.

For help, visit ${APP_URL}/guide
For queries: www.aylesburyhindutemple.org`,
  },
  {
    id: "social",
    title: "Social Media Post",
    content: `Our community needs YOUR voice! 🙏

Buckinghamshire Council is planning new developments across Aylesbury. The Aylesbury Hindu Temple is coordinating our community's response.

Pre-filled responses you can review and submit in 10-15 minutes from your own device.

${APP_URL}

Learn more: www.aylesburyhindutemple.org

#AylesburyHinduTemple #BucksLocalPlan #CommunityMatters #HinduCommunity`,
  },
];

export default function OutreachKit() {
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = async (id, text) => {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  return (
    <div className="public-page">
      <header className="public-header">
        <div className="public-header-inner">
          <div className="guide-header-row">
            <div className="public-logo">
              <img src="/aht_round_orange.png" alt="AHT" style={{ height: 36, width: 36, borderRadius: "50%" }} />
              <span className="dash-logo-text">Aylesbury Hindu Temple</span>
            </div>
            <Link to="/join" className="guide-back-link">
              <ArrowLeft size={14} /> Back to Share
            </Link>
          </div>
        </div>
      </header>

      <main className="outreach-page">
        <h1 style={{ fontSize: "24px", fontWeight: 700, marginBottom: "8px" }}>Outreach Templates</h1>
        <p style={{ color: "var(--cf-muted)", marginBottom: "24px" }}>
          Ready-made messages for community leaders. Copy and paste into WhatsApp, email, or social media.
        </p>

        {TEMPLATES.map((t) => (
          <div key={t.id} className="outreach-template">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
              <h3>{t.title}</h3>
              <button
                className="btn-secondary btn-sm"
                onClick={() => handleCopy(t.id, t.content)}
              >
                {copiedId === t.id ? <Check size={12} /> : <Copy size={12} />}
                <span>{copiedId === t.id ? "Copied!" : "Copy"}</span>
              </button>
            </div>
            <pre>{t.content}</pre>
          </div>
        ))}

        <div style={{ textAlign: "center", marginTop: "32px", padding: "16px 0", borderTop: "1px solid var(--cf-card-border)", color: "var(--cf-muted)", fontSize: 13 }}>
          <p style={{ margin: 0 }}>
            An initiative by <strong style={{ color: "var(--cf-orange)" }}>Aylesbury Hindu Temple &amp; Trust</strong> · <a href="https://www.aylesburyhindutemple.org" target="_blank" rel="noopener noreferrer" style={{ color: "var(--cf-orange)" }}>www.aylesburyhindutemple.org</a>
          </p>
          <p style={{ margin: "8px 0 0", fontSize: 11, opacity: 0.7 }}>
            Built by <a href="https://scaleright.ai/" target="_blank" rel="noopener noreferrer" style={{ color: "var(--cf-orange)" }}>ScaleRight.ai</a>
          </p>
        </div>
      </main>
    </div>
  );
}
